'use strict';

import * as config from '../../js/config';
import RichRelevancePlacement from './RichRelevance-Placement';

// This is a base class and should only ever be extended to set API end point.
export class RichRelevanceProductPlacement extends RichRelevancePlacement {
  initializeOptions() {
    this.endPointUrl = config.urls.richRelevance.products;
  }
}

export function create($parent) {
  $parent.find('.RichRelevance-ProductPlacement').each(function() {
    new RichRelevanceProductPlacement(this);
  });
}



// WEBPACK FOOTER //
// ./assets/components/RichRelevance/RichRelevance-ProductPlacement.js